import { BaseComponent } from "../../base.component";
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';

export class QuoteAssistv2BaseComponent extends BaseComponent {
  isTrackingEnabled:string='false';
  
// Create HTML template with CSS styling - matching target design exactly
 downloadPdfFileFromResponse(response: any,pdfParams:any):void {
        let filename = `Quote_${pdfParams.companyId}_${pdfParams.rfqId}.pdf`; // Default filename based on parameters
        const blob = new Blob([response.body], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        this.createClickRemoveLink(url, filename);
  }
createClickRemoveLink(url: string, filename: string=''){
   const link = document.createElement('a');
  link.href = url;
  if(filename){
    link.download = filename;
    link.target = '_blank';
  }
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  if(url.startsWith('blob:')){
    window.URL.revokeObjectURL(url);
  }
}
  addTracking( mixPanelEvent: string, queryParams: any,  dataToSend: any = {}){
    if (window.parent && mixPanelEvent) {
      let dataToEmit: any = Object.assign({ isQuoteAssistTracking: true }, queryParams);
      dataToEmit = Object.assign(dataToEmit, dataToSend)
      dataToEmit["eventName"] = mixPanelEvent;
      window.parent.postMessage(dataToEmit, "*");
    }
  }
}